module.exports = __webpack_public_path__ + "static/media/logout.e71fb551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/logout.svg
// module id = 137
// module chunks = 0